import React, { useState } from 'react';
import { Box, Grid, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import MatrixCard from 'components/matrixCard/MatrixCard';
import MoreDetails from 'components/moreDetails/MoreDetails';
import VehicleInfo from 'pages/vendor/driverVendor/VehicleInfo';
import { subVendorVechileMatrix } from './VehiceData';

const VehicleTabList = (props) => {
  const {
    vehicleData,
    vehicleInfotable,
    vehicleInfoaminities,
    vehicleMoreData,
    vehicleMatrixData,
    editButton
  } = props;

  const [value, setValue] = useState('matrix');

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box className="mt30">
      <Grid container>
        <Grid item className="tabContainer" xs={12}>
          <Box className="contentBoxStyle">
            <TabContext value={value}>
              <Grid
                container
                className="tabBoxStyle"
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <TabList
                    onChange={handleTabChange}
                    aria-label="lab API tabs example"
                    TabIndicatorProps={{
                      style: { backgroundColor: 'white' },
                    }}
                  >
                    <Tab label="Matrix" value="matrix" className="tabStyle" />
                    <Tab
                      label="More Details"
                      value="moreDetails"
                      className="tabStyle"
                    />
                    <Tab
                      label="Vehicle Info"
                      value="vehicleInfo"
                      className="tabStyle"
                    />
                  </TabList>
                </Grid>
              </Grid>
              <TabPanel value="matrix" className="matrix">
                <MatrixCard
                  matrix={subVendorVechileMatrix(vehicleMatrixData)}
                />
              </TabPanel>
              <TabPanel value="moreDetails" className="moreDetails mt30">
                <MoreDetails details={vehicleMoreData} />
              </TabPanel>
              <TabPanel value="vehicleInfo" className="vehicleInfo mt30">
                <VehicleInfo
                  vehicleData={vehicleData}
                  vehicleInfo={vehicleInfotable}
                  vehicleImage={vehicleMoreData}
                  amenitiesVehicle={vehicleInfoaminities}
                  editButton={editButton}
                />
              </TabPanel>
            </TabContext>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VehicleTabList;
